import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Grid, withStyles } from '@material-ui/core';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import parseQuerystring from '../../../helpers/parseQuerystring';
import OutlinedSelectChippedInput from '../../shared/Inputs/OutlinedSelectChipped';
import TextFieldInput from '../../shared/Inputs/TextField';
import AutocompleteInput from '../../shared/Inputs/Autocomplete';
import CollapseWrapper from '../../shared/CollapseWrapper.js';

import _debounce from 'lodash/debounce';
import _pickBy from 'lodash/pickBy';
import _pick from 'lodash/pick';

import combineStyles from '../../../helpers/combineStyles';
import SpacingStyles from '../../../styles/helpers/spacing';

import { filterListFuzzyly } from '../../../helpers/utilityFunctions';
import { hasSecurityQuestionsOptions, statusOptions } from './dropDownOptions';
import { DEFAULT_DEBOUNCE_DELAY } from '../../../constants/request_constants';

class PointOfSaleFilters extends PureComponent {
  state = {
    name: '',
    supplier: '',
    status: 'todos',
    hasSecurityQuestions: 'todos',
    hasFingerprintBiometric: 'todos',
    canSellWithGeneralWarranty: 'todos',
  };

  componentDidMount() {
    const query = parseQuerystring(this.props);
    this.setState({
      ...this.state,
      ...query
    });
  }

  _searchCallback = _debounce(
    (attribute, value) => {
      this.setState({ [attribute]: value, page: 0 }, this._handleChangeFilter);
    },
    DEFAULT_DEBOUNCE_DELAY,
    {
      leading: false,
      trailing: true
    }
  );

  _handleChange = ({ target: { name, value } }) => {
    this._searchCallback(name, value);
  };

  _getSuggestions = async value => {
    const suppliers = this.props.suppliers.map(supplier => ({
      label: supplier.name,
      value: supplier.id
    }));

    const suggestions = filterListFuzzyly(value, suppliers, 'label');

    return Promise.resolve(suggestions);
  };

  _handleSelectChange = ({ target: { name, value } }) =>
    this.setState({ [name]: value }, this._handleChangeFilter);

  _handleChangeFilter = () =>
    this.props.onChangeFilter(this._getFilterParams());

  _getFilterParams = () => {
    const filterParams = _pick(
      _pickBy(this.state, filter => !!filter),
      'name',
      'supplier',
      'status',
      'hasSecurityQuestions',
      'hasFingerprintBiometric',
      'canSellWithGeneralWarranty',
    );
    return filterParams;
  };

  render() {
    const { classes, suppliers } = this.props;
    return (
      <CollapseWrapper
        filter={true}
        body={
          <Fragment>
            <Grid container spacing={16}>
              <Grid item xs={12} sm={2}>
                <TextFieldInput
                  id="name"
                  name="name"
                  value={this.state.name}
                  onChange={this._handleChange}
                  label="Nombre Punto de Venta"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <AutocompleteInput
                  id="supplier"
                  name="supplier"
                  label="Nombre Proveedor"
                  margin="normal"
                  variant="outlined"
                  error={''}
                  helperText={''}
                  value={this.state.supplier || ''}
                  onChange={change => {
                    if (this.state.supplier && !change) {
                      this._handleSelectChange({
                        target: { name: 'supplier', value: '' }
                      });
                    }
                    this.setState({
                      supplier: change,
                      selectedSupplier: false
                    });
                  }}
                  suggestions={suppliers}
                  getSuggestions={this._getSuggestions}
                  onSuggestionSelected={supplier => {
                    this._handleSelectChange({
                      target: { name: 'supplier', value: supplier.label }
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Estado'}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  name={'status'}
                  options={statusOptions}
                  onChange={this._handleSelectChange}
                  inputLabel={'Status'}
                  value={this.state.status}
                  withChip={false}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Tiene preguntas reto'}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  name={'hasSecurityQuestions'}
                  options={hasSecurityQuestionsOptions}
                  onChange={this._handleSelectChange}
                  inputLabel={'HasSecurityQuestions'}
                  value={this.state.hasSecurityQuestions}
                  withChip={false}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Biometría dactilar'}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  name={'hasFingerprintBiometric'}
                  options={hasSecurityQuestionsOptions}
                  onChange={this._handleSelectChange}
                  inputLabel={'HasFingerprintBiometric'}
                  value={this.state.hasFingerprintBiometric}
                  withChip={false}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Puede vender a no títular sin codeudor'}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  name={'canSellWithGeneralWarranty'}
                  options={hasSecurityQuestionsOptions}
                  onChange={this._handleSelectChange}
                  inputLabel={'canSellWithGeneralWarranty'}
                  value={this.state.canSellWithGeneralWarranty}
                  withChip={false}
                />
              </Grid>
            </Grid>
          </Fragment>
        }
      />
    );
  }
}

const styles = theme => ({
  root: {
    marginBottom: theme.spacing.unit * 3
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '1.2em',
    color: '#CACACA'
  },
  actionBar: {
    marginTop: theme.spacing.unit * 2.2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

PointOfSaleFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default compose(
  withRouter,
  withStyles(combineStyles(styles, SpacingStyles), { withTheme: true })
)(PointOfSaleFilters);
